import React from "react";
import { BUTTON_CONSTANTS } from "./InActiveSchedulers";

import { Button, Icon, Popconfirm } from "antd";
import { Translate } from "react-translated";
import { Link } from "react-router-dom";
import EditIcon from "../../../assets/edit-icon-3.png";
import PlusIcon from "../../../assets/Plus-icon.png";

const ActionButtonRenderer = (props) => {
  const { data, onButtonClick } = props;

  const handleButtonClick = (buttonType) => {
    if (buttonType === BUTTON_CONSTANTS.edit_user.key) {
      onButtonClick(buttonType, data);
    } else if (buttonType === BUTTON_CONSTANTS.enable_user.key) {
      onButtonClick(buttonType, data);
    }
  };
  // to={"/manage-users/edit-user/" + user.id}
  return (
    <div style={{ display: "flex", gap: "6px", marginTop: "7px" }}>
      <Link
        to={"/manage-users/edit-user/" + data.id}
        style={{ display: "flex" }}
      >
        <Button
          className="borderRadius-28"
        >
          <img src={EditIcon} alt="Edit Icon" />
          &nbsp;
          {BUTTON_CONSTANTS.edit_user.label}
        </Button>
      </Link>
      <Button
        className="borderRadius-28"
        style={{ marginLeft: 10 }}
        onClick={() => handleButtonClick(BUTTON_CONSTANTS.enable_user.key)}
      >
        <img src={PlusIcon} alt="Edit Icon" />&nbsp;
        <Translate text={`${BUTTON_CONSTANTS.enable_user.label}`} />
      </Button>
    </div>
  );
};

export default ActionButtonRenderer;



// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/InActive Schedulers/ActionButtonRenderer.js